import {
	hideLoadingScreen,
	router,
	setPageContent,
	showLoadingScreen,
} from "..";
import { signIn } from "../api/sign-in";
import { locale } from "../locale";
import { state } from "../state";
import { Bulma } from "../view/bulma";
import { centeredBox, passwordInput } from "../view/components";

function signInPage() {
	const email = Bulma.input({
		type: "email",
	});

	const password = passwordInput();

	const onclickSignIn = () => {
		showLoadingScreen();
		signIn(email.getValue(), password.getValue())
			.then(() => state.loadDevices())
			.then(() => state.getSignedInUser())
			.then((user) => {
				if (user.AccountType === "smartplug2-factory") {
					router.jump("/factory/smartplug2");
				} else {
					router.jump("/devices");
				}
			})
			.finally(hideLoadingScreen);
	};

	setPageContent(
		centeredBox(
			"small",
			Bulma.title(locale.strings.signIn),
			Bulma.field(
				{},
				Bulma.label(locale.strings.email),
				Bulma.control({}, email.element),
			),
			Bulma.field(
				{},
				Bulma.label(locale.strings.password),
				password.element,
			),
			Bulma.buttons(
				Bulma.button(
					{
						onClick: onclickSignIn,
						styles: ["is-fullwidth", "is-primary"],
					},
					locale.strings.signIn,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/create-account"),
						styles: ["is-fullwidth", "is-primary", "is-small"],
					},
					locale.strings.createAccount,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/reset-password"),
						styles: ["is-fullwidth", "is-primary", "is-small"],
					},
					locale.strings.resetPassword,
				),
				Bulma.button(
					{
						onClick: () => router.jump("/verify-account"),
						styles: ["is-fullwidth", "is-primary", "is-small"],
					},
					locale.strings.verifyAccount,
				),
			),
		),
	);
}

export { signInPage };
